var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading"},[_c('i',{staticClass:"fas fa-5x fa-spinner fa-pulse"})])
}]

export { render, staticRenderFns }